import { render, staticRenderFns } from "./SelloRangos.vue?vue&type=template&id=55446b79"
import script from "./SelloRangos.vue?vue&type=script&lang=js"
export * from "./SelloRangos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports